/* eslint-disable max-len */
import React from 'react';
function BulkAction() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M20.2728 17.5454V3.72724H6.45457V2H20.2728C21.2228 2 22 2.77729 22 3.72724V17.5454H20.2728ZM4.72729 21C3.77729 21 3 20.2228 3 19.2727V7.18181C3 6.23181 3.77729 5.45452 4.72729 5.45452H16.8182C17.7682 5.45452 18.5455 6.23181 18.5455 7.18181V19.2727C18.5455 20.2228 17.7682 21 16.8182 21H4.72729ZM4.72729 19.2727H16.8182V7.18181H4.72729V19.2727ZM9.21429 17L6 13.6411L6.90643 12.6938L9.21429 15.0989L14.0936 10L15 10.9539L9.21429 17Z" })));
}
export default BulkAction;
